import { useMemo } from 'react'
import ListUser from '../modules/Users/ListUser'
import User from '../modules/Users/User'
import Settings from '../modules/Settings/Settings'
import UserSettings from '../modules/Users/UserSettings'
import Company from '../modules/Company/Company'
import CalendarPage from '../modules/Calendar/Calendar'
import MailBox from '../modules/emails/MailBox'
import ListCustomers from '../modules/Customers/ListCustomer'
import EditCustomer from '../modules/Customers/EditCustomer'
import ViewCustomer from '../modules/Customers/ViewCustomer'
import ListQuotes from '../modules/Quotes/ListQuotes'
import EditQuote from '../modules/Quotes/EditQuote'
import ViewQuote from '../modules/Quotes/ViewQuote'
import ListInvoice from '../modules/Invoices/ListInvoices'
import EditInvoice from '../modules/Invoices/EditInvoice'
import ViewInvoice from '../modules/Invoices/ViewInvoice'
import ListCreditNote from '../modules/CreditNotes/ListCreditNotes'
import EditCreditNote from '../modules/CreditNotes/EditCreditNote'
import ShowCreditNote from '../modules/CreditNotes/ViewCreditNote'
import ListIncomes from '../modules/Accounting/ListIncome'
import Income from '../modules/Accounting/Income'
import ListOutcome from '../modules/Accounting/ListOutcome'
import Outcome from '../modules/Accounting/Outcome'
import ListTax from '../modules/Accounting/ListTax'
import Tax from '../modules/Accounting/Tax'
import ListRoles from '../modules/Roles/ListRoles'
import Role from '../modules/Roles/Role'
import ListSupplier from '../modules/Suppliers/ListSupplier'
import EditSupplier from '../modules/Suppliers/EditSupplier'
import ViewSupplier from '../modules/Suppliers/ViewSupplier'
import ListInterventions from '../modules/Interventions/ListInterventions'
import EditIntervention from '../modules/Interventions/EditIntervention'
import ViewIntervention from '../modules/Interventions/ViewIntervention'
import ListPriceBook from '../modules/Pricebook/ListPriceBook'
import PriceBook from '../modules/Pricebook/PriceBook'
import ListContract from '../modules/Contracts/ListContract'
import EditContract from '../modules/Contracts/EditContract'
import ViewContract from '../modules/Contracts/ViewContract'
import SuperAdmin from '../modules/SuperAdmin/SuperAdmin'
import useAccessControl from '../hooks/useAccessControl'
import Dashboard from '../modules/Dashboard/Dashboard'
import Accounting from '../modules/Accounting/Accounting'
import ListProduct from '../modules/Products/ListProduct'

const useFilteredRoutes = () => {
  const { hasAccess } = useAccessControl()

  const allRoutes = useMemo(
    () => [
      { path: '/', rights: { module: 'Dashboard', is_access: true }, element: <Dashboard /> },
      { path: '/users', rights: { module: 'Users', is_list: true }, element: <ListUser /> },
      { path: '/users/edit', rights: { module: 'Users', is_edit: true }, element: <User /> },
      { path: '/users/add', rights: { module: 'Users', is_add: true }, element: <User /> },
      { path: '/users/view', rights: { module: 'Users', is_view: true }, element: <User /> },
      { path: '/settings', rights: { module: 'Settings', is_view: true }, element: <Settings /> },
      { path: '/settings/edit', rights: { module: 'Settings', is_edit: true }, element: <Settings /> },
      { path: '/mysettings', rights: { module: 'MySettings', is_view: true }, element: <UserSettings /> },
      { path: '/myprofile', rights: { module: 'MyProfile', is_view: true }, element: <User /> },
      { path: '/company', rights: { module: 'Company', is_view: true }, element: <Company /> },
      { path: '/company/edit', rights: { module: 'Company', is_edit: true }, element: <Company /> },
      { path: '/calendar', rights: { module: 'Events', is_access: true }, element: <CalendarPage /> },
      { path: '/emails', rights: { module: 'Emails', is_access: true }, element: <MailBox /> },
      { path: '/customers', rights: { module: 'Customers', is_list: true }, element: <ListCustomers /> },
      { path: '/customers/edit', rights: { module: 'Customers', is_edit: true }, element: <EditCustomer /> },
      { path: '/customers/add', rights: { module: 'Customers', is_add: true }, element: <EditCustomer /> },
      { path: '/customers/view', rights: { module: 'Customers', is_view: true }, element: <ViewCustomer /> },
      { path: '/quotes', rights: { module: 'Quotes', is_list: true }, element: <ListQuotes /> },
      { path: '/quotes/edit', rights: { module: 'Quotes', is_edit: true }, element: <EditQuote /> },
      { path: '/quotes/add', rights: { module: 'Quotes', is_add: true }, element: <EditQuote /> },
      { path: '/quotes/view', rights: { module: 'Quotes', is_view: true }, element: <ViewQuote /> },
      { path: '/invoices', rights: { module: 'Invoices', is_list: true }, element: <ListInvoice /> },
      { path: '/invoices/edit', rights: { module: 'Invoices', is_edit: true }, element: <EditInvoice /> },
      { path: '/invoices/add', rights: { module: 'Invoices', is_add: true }, element: <EditInvoice /> },
      { path: '/invoices/view', rights: { module: 'Invoices', is_view: true }, element: <ViewInvoice /> },
      { path: '/creditNotes', rights: { module: 'CreditNotes', is_list: true }, element: <ListCreditNote /> },
      { path: '/creditNotes/edit', rights: { module: 'CreditNotes', is_edit: true }, element: <EditCreditNote /> },
      { path: '/creditNotes/add', rights: { module: 'CreditNotes', is_add: true }, element: <EditCreditNote /> },
      { path: '/creditNotes/view', rights: { module: 'CreditNotes', is_view: true }, element: <ShowCreditNote /> },
      { path: '/accounting', rights: { module: 'Income', is_list: true }, element: <Accounting /> },
      { path: '/incomes', rights: { module: 'Income', is_list: true }, element: <ListIncomes /> },
      { path: '/incomes/edit', rights: { module: 'Income', is_edit: true }, element: <Income /> },
      { path: '/incomes/add', rights: { module: 'Income', is_add: true }, element: <Income /> },
      { path: '/incomes/view', rights: { module: 'Income', is_view: true }, element: <Income /> },
      { path: '/outcomes', rights: { module: 'Income', is_list: true }, element: <ListOutcome /> },
      { path: '/outcomes/edit', rights: { module: 'Income', is_edit: true }, element: <Outcome /> },
      { path: '/outcomes/add', rights: { module: 'Income', is_add: true }, element: <Outcome /> },
      { path: '/outcomes/view', rights: { module: 'Income', is_view: true }, element: <Outcome /> },
      { path: '/tax', rights: { module: 'Income', is_list: true }, element: <ListTax /> },
      { path: '/tax/edit', rights: { module: 'Income', is_edit: true }, element: <Tax /> },
      { path: '/tax/add', rights: { module: 'Income', is_add: true }, element: <Tax /> },
      { path: '/tax/view', rights: { module: 'Income', is_view: true }, element: <Tax /> },
      { path: '/roles', rights: { module: 'Roles', is_list: true }, element: <ListRoles /> },
      { path: '/roles/edit', rights: { module: 'Roles', is_edit: true }, element: <Role /> },
      { path: '/roles/add', rights: { module: 'Roles', is_add: true }, element: <Role /> },
      { path: '/roles/view', rights: { module: 'Roles', is_view: true }, element: <Role /> },
      { path: '/suppliers', rights: { module: 'Suppliers', is_list: true }, element: <ListSupplier /> },
      { path: '/suppliers/edit', rights: { module: 'Suppliers', is_edit: true }, element: <EditSupplier /> },
      { path: '/suppliers/add', rights: { module: 'Suppliers', is_add: true }, element: <EditSupplier /> },
      { path: '/suppliers/view', rights: { module: 'Suppliers', is_view: true }, element: <ViewSupplier /> },
      { path: '/interventions', rights: { module: 'Interventions', is_list: true }, element: <ListInterventions /> },
      {
        path: '/interventions/edit',
        rights: { module: 'Interventions', is_edit: true },
        element: <EditIntervention />
      },
      { path: '/interventions/add', rights: { module: 'Interventions', is_add: true }, element: <EditIntervention /> },
      {
        path: '/interventions/view',
        rights: { module: 'Interventions', is_view: true },
        element: <ViewIntervention />
      },
      { path: '/priceBooks', rights: { module: 'PriceBook', is_list: true }, element: <ListPriceBook /> },
      { path: '/priceBooks/edit', rights: { module: 'PriceBook', is_edit: true }, element: <PriceBook /> },
      { path: '/priceBooks/add', rights: { module: 'PriceBook', is_add: true }, element: <PriceBook /> },
      { path: '/priceBooks/view', rights: { module: 'PriceBook', is_view: true }, element: <PriceBook /> },
      { path: '/products', rights: { module: 'Product', is_list: true }, element: <ListProduct /> },
      { path: '/contracts', rights: { module: 'Contracts', is_superAdmin: true }, element: <ListContract /> },
      { path: '/contracts/edit', rights: { module: 'Contracts', is_superAdmin: true }, element: <EditContract /> },
      { path: '/contracts/add', rights: { module: 'Contracts', is_superAdmin: true }, element: <EditContract /> },
      { path: '/contracts/view', rights: { module: 'Contracts', is_superAdmin: true }, element: <ViewContract /> },
      { path: '/tables', rights: { module: 'Tables', is_superAdmin: true }, element: <SuperAdmin /> }
    ],
    []
  )
  const filteredRoutes = useMemo(() => {
    return allRoutes.filter((route) => hasAccess(route.rights))
  }, [allRoutes, hasAccess])

  return filteredRoutes
}

export default useFilteredRoutes
